import React from "react";
import { Component } from "react";
import { translate } from "../../utils/useful";

export default class Automation extends Component {
    state = {
        triggers: [
            { text: 'When a record matches conditions', img: '/assets/profile-def.png' },
            { text: 'When a form is submitted', img: '/assets/profile-def.png' }
        ],
        type: 'trigger'
    }
    render() {
        return (
            <this.box
                type='trigger' />
        );
    }

    trigger = () => {
        return (
            <div className="pt-2 pld-2">
                <button style={{ width: '300px', height: '50px', border: '2px dashed rgb(227,227,227)', borderRadius: '3px' }}>
                    <p style={{ color: 'rgb(59,135,249)' }}>{translate('+ Add trigger')}</p>
                </button>
                <div className="connection-line" style={{ width: '2px', height: '30px', transform: 'translateX(3px)', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                </div>
            </div>
        )
    }

    action = () => {
        return (
            <div className=" pld-2 d-flex flex-column">
                <div style={{ display: 'inline-flex' }}>
                    <div style={{ transform: 'translateX(3px)' }}>
                        <div className="connection-line" style={{ width: '2px', height: '50%', minHeight: '25px', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                        </div>
                        <div className="connection-line" style={{ width: '50px', height: '2px', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                        </div>
                    </div>
                    {/* hover #9cc7ff */}
                    <div className="m-1 pld-2 p-2 flex d-flex flex-column box-white" style={{}}>
                        <div className="pld-1 pb-2" style={{ justifyContent: 'left' }}>
                            <p className="font-bold text-normal" style={{ lineHeight: '18px', color: 'rgb(77,77,77)' }}>{translate('Run action')}</p>
                        </div>
                        <div>
                            <div className="pld-1" style={{ justifyContent: 'left' }}>
                                <p className="text-smallest pb-2" style={{ justifyContent: 'left', lineHeight: '18px', color: 'rgb(102, 102, 102)', fontStyle: 'italic' }}>{translate('This group is empty-no actions will run when triggered')}</p>
                            </div>
                            <div className="d-flex flex-column flexcc">
                                <button className="box-gray" style={{}}>
                                    <p className="text-smaller" style={{ color: 'rgb(59,135,249)' }}>{translate('+ Add action')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    actions = () => {
        return (<div>
            <div className=" pld-2 d-flex flex-column">
                <div style={{ display: 'inline-flex' }}>
                    <div style={{ transform: 'translateX(3px)' }}>
                        <div className="connection-line" style={{ width: '2px', height: '50%', minHeight: '25px', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                        </div>
                        <div className="connection-line" style={{ width: '50px', height: '2px', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                        </div>
                        <div className="connection-line" style={{ width: '2px', height: '50%', minHeight: '25px', backgroundColor: 'rgb(227,227,227)', border: '1px solid rgb(227,227,227)' }}>
                        </div>
                    </div>
                    <div className="m-1 pld-2 p-2 flex d-flex flex-column box-white" style={{}}>
                        <div className="pld-1 pb-2" style={{ justifyContent: 'left' }}>
                            <p className="font-bold text-normal" style={{ lineHeight: '18px', color: 'rgb(77,77,77)' }}>{translate('Run action')}</p>
                        </div>
                        <div>
                            <div className="pld-1" style={{ justifyContent: 'left' }}>
                                <p className="text-smallest pb-2" style={{ justifyContent: 'left', lineHeight: '18px', color: 'rgb(102, 102, 102)', fontStyle: 'italic' }}>{translate('This group is empty-no actions will run when triggered')}</p>
                            </div>
                            <div className="d-flex flex-column flexcc">
                                <button className="box-gray" style={{}}>
                                    <p className="text-smaller" style={{ color: 'rgb(59,135,249)' }}>{translate('+ Add action')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
    triggerBox = () => {
        return (
            <div className="pt-2 pld-2">
                <button style={{ width: '300px', height: '50px', border: '2px dashed rgb(227,227,227)', borderRadius: '3px' }}>
                    <p style={{ color: 'rgb(59,135,249)' }}>{translate('+ Add trigger')}</p>
                </button>
            </div>
        )
    }
    box = (type) => {
        return (
            <div>
                <div className=" pld-2 d-flex flex-column">
                    <div style={{ display: 'inline-flex' }}>
                        <div className="m-1 pld-2 p-2 flex d-flex flex-column box-white" style={{}}>
                            <div className="pld-1 pb-2" style={{ justifyContent: 'left' }}>
                                {/* {console.log('type', type)} */}
                                <p className="font-bold text-normal" style={{ lineHeight: '18px', color: 'rgb(77,77,77)' }}>{type === 'trigger' ? translate('Run trigger') : translate('Run actions')}</p>
                            </div>
                            <div>
                                <div className="pld-1" style={{ justifyContent: 'left' }}>
                                    <p className="text-smallest pb-2" style={{ justifyContent: 'left', lineHeight: '18px', color: 'rgb(102, 102, 102)', fontStyle: 'italic' }}>{translate('This group is empty-no actions will run when triggered')}</p>
                                </div>
                                <div className="d-flex flex-column flexcc">
                                    <button className="box-gray" style={{}}>
                                        <p className="text-smaller" style={{ color: 'rgb(59,135,249)' }}>{translate('+ Add action')}</p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

